import ListItemIcon from '@mui/material/ListItemIcon';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import NavLinkListItem from '../../NavLinkListItem/NavLinkListItem';

const useStyles = makeStyles()((theme: Theme) => ({
    primaryColor: {
        backgroundColor: theme.palette.sidebarHeader.main,
    },
    root: {
        position: 'relative',
        padding: '0 0 100%',
    },
    wrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    icon: {
        minWidth: 'unset',
        color: theme.palette.secondary.contrastText,
        '& .MuiSvgIcon-root': {
            [theme.breakpoints.up('xl')]: {
                fontSize: '1.75rem',
            },
        },
    },
}));

interface Props {
    navTarget: string;
    //selected: boolean;
    children: React.ReactElement;
    primaryColor: boolean;
    className?: string;
}

export default function NavListLink({ navTarget, children, primaryColor, className = '' }: Props) {
    const { classes } = useStyles();

    return (
        <div className={primaryColor ? classes.primaryColor : ''}>
            <NavLinkListItem pathname={navTarget} disableGutters className={classes.root}>
                <div className={classes.wrapper}>
                    <ListItemIcon className={classes.icon + ' ' + className}>
                        {children}
                    </ListItemIcon>
                </div>
            </NavLinkListItem>
        </div>
    );
}
